import React, { Suspense } from 'react';
import { Loading } from '@app/components/common/Loading';

type LoadingWrappedComponent<TProps = Record<string, never>> = React.FC<TProps>;

export const withLoading = <TProps,>(
  Component: React.ComponentType<TProps>
): LoadingWrappedComponent<TProps> => {
  return (props: TProps) => (
    <Suspense fallback={<Loading />}>
      <Component {...props} />
    </Suspense>
  );
};
